import { graphql } from "react-relay";

export const subscription = graphql`
  subscription UpdateEventParentBaseWrappersSubscription(
    $input: UpdateEventParentBaseWrappersSubscriptionInput!
  ) {
    updateEventParentBaseWrapper(input: $input) {
      eventParentBases {
        id
        timestamp
      }

      eventParents {
        __typename
        id

        externalEventId
        eventParentBaseId
        eventParentBaseTimestamp
        events {
          id
          title
          locked
          isClockwiseEvent
          isAllDay
          calendarIds
          organizer {
            urnValue
            responseStatus
          }
          attendees {
            urnValue
            responseStatus
          }
          creator {
            urnValue
          }
          annotatedEvent {
            userTags {
              tag
              states {
                subjectType
                subjectValue
                value
              }
            }
            orgTags {
              tag
              state {
                subjectType
                subjectValue
                value
              }
            }
          }
          eventKey {
            externalEventId
          }
          location
          startTime {
            dateOrDateTime
          }
          endTime {
            dateOrDateTime
          }
        }
      }
    }
  }
`;
